import { useContext, useState } from 'react'
import * as SETTINGS from '../../../constants/settings'
import { AuthenticationContext } from '../../../context/authenticationContext'
import { SiteConfigContext } from '../../../context/siteConfigContext'
import CustomBadge from '../../../graphics/Badge/CustomBadge'

export default function CustomBadges({ user }) {
  const { getSubType } = useContext(AuthenticationContext)
  const { [SETTINGS.MEMBERSHIPS.key]: memberships } =
    useContext(SiteConfigContext)
  const [subType] = useState(getSubType({ user }))

  return (
    <>
      {memberships.main.map((bdg, index) => {
        return (
          subType === bdg.subType &&
          bdg.badge && <CustomBadge key={index} badge={bdg.badge} />
        )
      })}
    </>
  )
}
